<template>
  <div class="container">
    <swiper ref="mySwiper" :options="swiperOption" @slideChange="slideChange">
      <SwiperSlide>
        <div class="top">
          <img src="./img/bg.jpg" alt="" />
          <div class="text-box">
            <div class="left">一站式地理信息服务提供商</div>
            <!-- <div class="right">景中有序</div> -->
            <div class="bottom">——掌握国内领先GIS技术的国家级高新技术企业</div>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div class="ability">
          <div class="title">
            <div class="icon">
              <img src="./img/icon.png" alt="" />
            </div>
            <div class="name">地图能力</div>
          </div>
          <div class="text">多样化的地图展示方式、丰富的地理空间信息数据以及地图工具，为每个项目量身打造专属地图平台。</div>
          <div class="swiper">
            <el-carousel :interval="4000" type="card" height="410px" indicator-position="none">
              <el-carousel-item v-for="item in list" :key="item.index">
                <img :src="item.imgUrl" alt="" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <a class="more">
            <div class="text-more">了解更多</div>
            <div class="allow">
              <img src="./img/allow.png" alt="" />
            </div>
          </a>
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div class="programme">
          <div class="title1">
            <div class="icon">
              <img src="./img/fangan.png" alt="" />
            </div>
            <div class="name">解决方案</div>
          </div>
          <div class="contnet">
            <ul class="ul">
              <li v-for="(item, index) in programme" :key="index" class="li">
                <div class="title">{{ item.title }}</div>
                <div class="img">
                  <img :src="item.imgUrl" alt="" />
                </div>
                <!-- <div class="text">
              <div class="text-title">{{ item.title }}</div>
              <div class="words">{{ item.content }}</div>
            </div> -->
              </li>
            </ul>
          </div>
          <a class="more">
            <div class="text-more">了解更多</div>
            <div class="allow">
              <img src="./img/allow.png" alt="" />
            </div>
          </a>
        </div>
      </SwiperSlide>
    </swiper>

    <!-- <div class="case">
      <div class="title">
        <div class="icon">
          <img src="./img/kehu.png" alt="" />
        </div>
        <span class="name">客户案例</span>
      </div>
      <div class="scroll">
        <vuescroll :ops="ops">
          <ul class="ul">
            <li class="li" v-for="(item, index) in icon" :key="index">
              <img :src="item.imgUrl" alt="" />
            </li>
          </ul>
        </vuescroll>
      </div>
    </div> -->
  </div>
</template>

<script>
import 'swiper/css/swiper.css';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

var debounce = (fn, wait) => {
  let timer;
  let startTimeStamp = 0;
  let context, args;

  let run = timerInterval => {
    timer = setTimeout(() => {
      let now = new Date().getTime();
      let interval = now - startTimeStamp;
      if (interval < timerInterval) {
        // the timer start time has been reset, so the interval is less than timerInterval
        startTimeStamp = now;
        run(wait - interval); // reset timer for left time
      } else {
        fn.apply(context, args);
        clearTimeout(timer);
        timer = null;
      }
    }, timerInterval);
  };

  return function() {
    context = this;
    args = arguments;
    let now = new Date().getTime();
    startTimeStamp = now;

    if (!timer) {
      run(wait); // last timer alreay executed, set a new timer
    }
  };
};
export default {
  name: 'container',
  components: {
    Swiper,
    SwiperSlide
  },
  computed: {
    swiper() {
      // 实例swiper对象
      return this.$refs.mySwiper.$swiper;
    }
  },
  data() {
    return {
      ops: {
        scrollPanel: {
          scrollingX: true,
          scrollingY: true
        },
        vuescroll: {
          mode: 'native',
          wheelDirectionReverse: true
        },
        bar: {
          background: 'rgba(0,0,0,0)'
        }
      },
      list: [
        { imgUrl: require('./img/1.jpg'), title: '1' },
        { imgUrl: require('./img/2.jpg'), title: '1' },
        { imgUrl: require('./img/3.jpg'), title: '1' },
        { imgUrl: require('./img/4.jpg'), title: '1' },
        { imgUrl: require('./img/5.jpg'), title: '1' },
        { imgUrl: require('./img/6.jpg'), title: '1' },
        { imgUrl: require('./img/7.jpg'), title: '1' },
        { imgUrl: require('./img/8.jpg'), title: '1' },
        { imgUrl: require('./img/9.jpg'), title: '1' },
        { imgUrl: require('./img/10.jpg'), title: '1' }
      ],
      icon: [
        { imgUrl: require('./img/icon1.png') },
        { imgUrl: require('./img/icon2.png') },
        { imgUrl: require('./img/icon3.png') },
        { imgUrl: require('./img/icon4.png') },
        { imgUrl: require('./img/icon5.jpg') },
        { imgUrl: require('./img/icon6.jpg') },
        { imgUrl: require('./img/icon7.jpg') },
        { imgUrl: require('./img/icon8.png') },
        { imgUrl: require('./img/icon9.jpg') },
        { imgUrl: require('./img/icon10.png') },
        { imgUrl: require('./img/icon11.png') }
      ],
      programme: [
        {
          imgUrl: require('./img/village.jpg'),
          title: '数字乡村',
          content: '以GIS地图为基础，采用全面覆盖的感知网络以及新一代高速传输网络，搭建开放共享的业务平台服务体系，并且从运维、技术、管理三个层面建立统一保障的城市级信息安全体系，为政府构建一个高效的城市运营管理环境。'
        },
        {
          imgUrl: require('./img/scity.jpg'),
          title: '智慧城市',
          content: '公司从县市级全域旅游、镇级全域旅游、度假区旅游、智慧景区全产业链均有丰富的建设经验。智慧旅游建设内容主要包括智慧管理、智慧服务、智慧营销三部分组成。'
        },
        {
          imgUrl: require('./img/bcity.jpg'),
          title: '美丽城镇',
          content: '以4G/5G、三维GIS地图、物联网、云计算、大数据等新兴技术为支撑，整合政府资源实现“互联网+”模式，提高乡村智慧物联，并且采用网格化精细管理，提升乡村综合治理水平，优化民意收集渠道，建设乡村共商共治局面。 '
        },
        {
          imgUrl: require('./img/park.jpg'),
          title: '智慧园区',
          content: '以4G/5G、三维GIS地图、物联网、云计算、大数据等新兴技术为支撑，整合政府资源实现“互联网+”模式，提高乡村智慧物联，并且采用网格化精细管理，提升乡村综合治理水平，优化民意收集渠道，建设乡村共商共治局面。 '
        },
        {
          imgUrl: require('./img/tourism.jpg'),
          title: '智慧旅游',
          content: '以4G/5G、三维GIS地图、物联网、云计算、大数据等新兴技术为支撑，整合政府资源实现“互联网+”模式，提高乡村智慧物联，并且采用网格化精细管理，提升乡村综合治理水平，优化民意收集渠道，建设乡村共商共治局面。 '
        }
      ],
      swiperOption: {
        direction: 'vertical',
        mousewheel: {
          releaseOnEdges: true,
          sensitivity: 0.1
        },
        speed: 500
      }
    };
  },
  watch: {},
  methods: {
    slideChange() {
      if (this.swiper.activeIndex === this.swiper.slides.length - 1) {
        // console.log(this.swiper.mousewheel);
        // this.swiper.mousewheel.releaseScroll(true);
        this.swiper.mousewheel.disable();
        window.addEventListener('scroll', this.windowScroll);
      }
      window.scrollTo(0, 0);
    },
    windowScroll: debounce(function() {
      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop === 0) {
        // window.removeEventListener('scroll', this.windowScroll);
        this.swiper.mousewheel.enable();
      } else {
        this.swiper.mousewheel.disable();
      }
    }, 200)
  },
  destroyed() {
    window.removeEventListener('scroll', this.windowScroll);
  },
  mounted() {
    // document.querySelector('.container').style.height = window.screen.height + 'px';
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    if (scrollTop > 0) {
      this.swiper.mousewheel.disable();
      this.swiper.slideTo(this.swiper.slides.length - 1);
    }
    // let el = this.$refs.scroll;
    // const mousewheelEvent = e => {
    //   e = e || window.event;
    //   // e.wheelDelta ? (v = e.wheelDelta) : (v = e.detail);
    //   // if (v > 3 || -v > 3) v = -v;
    //   // v > 0 ? (a.scrollLeft += scroll_width) : (a.scrollLeft -= scroll_width);
    //   e.preventDefault();
    // };
    // el.addEventListener('DOMMouseScroll', mousewheelEvent, false);
    // this.$once('hook:beforeDestroy', () => {
    //   window.removeEventListener('DOMMouseScroll', mousewheelEvent);
    // });
  }
};
</script>

<style scoped lang="scss">
.container {
  position: relative;
  height: 100%;
  .swiper-container {
    height: 100%;
  }
  img {
    width: 100%;
  }
  .top {
    position: relative;
    .text-box {
      width: 860px;
      color: #fff;
      font-size: 70px;
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      .left {
        text-align: center;
        margin-bottom: 60px;
      }
      .right {
        text-align: right;
        margin-top: 50px;
      }
      .bottom {
        position: relative;
        left: 165px;
        text-align: center;
        margin-top: 50px;
        font-size: 28px;
      }
    }
  }
  .ability {
    width: 100%;
    height: 100%;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .title {
      display: flex;
      align-items: center;
      margin-top: 107px;
      .icon {
        width: 50px;
        height: 50px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .name {
        margin-left: 11px;
        font-size: 48px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #252525;
        line-height: 67px;
      }
    }
    .text {
      margin-top: 28px;
      width: 676px;
      height: 90px;
      font-size: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #252525;
      line-height: 30px;
    }
    .swiper {
      margin-top: 18px;
      width: 1342px;
      .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 200px;
        margin: 0;
      }
      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }
      /deep/ .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
      }
      /deep/ .el-carousel__item,
      .el-carousel__mask {
        position: absolute;
        height: 100%;
        img {
          height: 100%;
        }
      }
      /deep/ .is-active {
        height: 100%;
      }
    }
    .text-last {
      margin-left: 904px;
      margin-top: 28px;
      font-size: 28px;
      font-family: Helvetica;
      color: #252525;
    }
    .more {
      display: flex;
      align-items: center;
      margin-top: 38px;
      width: 180px;
      height: 50px;
      background: #f15031;
      border-radius: 30px;
      cursor: pointer;
      &:active {
        box-shadow: 0 0 3px #f15031;
      }
      .text-more {
        margin-left: 43px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 25px;
      }
      .allow {
        margin-left: 22px;
      }
    }
  }
  .programme {
    width: 100%;
    height: 1257px;
    background: #ffffff;
    border: 1px solid #979797;
    .title1 {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 107px;
      .icon {
        width: 50px;
        height: 50px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .name {
        margin-left: 11px;
        font-size: 48px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #252525;
        line-height: 67px;
      }
    }
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 60px;
      .icon {
        width: 50px;
        height: 50px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .name {
        margin-left: 11px;
        font-size: 48px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #252525;
        line-height: 67px;
      }
    }
    .contnet {
      height: 600px;
      padding: 0 240px;
      margin-top: 10px;
      .ul {
        height: 100%;
        display: flex;
        margin: 0 10%;
        justify-content: space-around;
        flex-flow: wrap;
        .li {
          width: 30%;
          display: flex;
          flex-direction: column;
          .img {
            position: relative;
            width: 100%;
            height: 180px;
            object-fit: cover;
            &::before {
              content: '';
              position: absolute;
              top: 10px;
              left: 10px;
              width: 100%;
              height: 180px;
              background: #444444;
              box-shadow: 0px 4px 4px 0px rgba(163, 163, 163, 0.5);
              z-index: 2;
              opacity: 0.1;
            }
            &::after {
              content: '';
              position: absolute;
              top: 20px;
              left: 20px;
              width: 100%;
              height: 180px;
              background: #444444;
              box-shadow: 0px 4px 4px 0px rgba(163, 163, 163, 0.5);
              opacity: 0.1;
              z-index: 1;
            }
            img {
              width: 100%;
              height: 100%;
              position: absolute;
              z-index: 3;
            }
          }
          .title {
            font-size: 30px;
            margin-bottom: 20px;
          }
        }
      }
    }
    .more {
      margin: 0 auto;
      display: flex;
      align-items: center;
      margin-top: 38px;
      width: 180px;
      height: 50px;
      background: #f15031;
      border-radius: 30px;
      cursor: pointer;
      &:active {
        box-shadow: 0 0 3px #f15031;
      }
      .text-more {
        margin-left: 43px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }
      .allow {
        margin-left: 22px;
      }
    }
  }
  .case {
    width: 100%;
    height: 725px;
    background: #ffffff;
    border: 1px solid #979797;
    .title {
      display: flex;
      justify-content: center;
      margin-top: 93px;
      .icon {
        width: 50px;
        height: 50px;
        img {
          height: 100%;
          width: 100%;
        }
      }
      .name {
        margin-left: 12px;
        font-size: 48px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #252525;
      }
    }
    .scroll {
      height: 550px;
      .ul {
        display: flex;
        padding: 200px 500px 0 500px;
        .li {
          margin-right: 30px;
          flex: none;
          width: 80px;
          height: 80px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
